import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import type { SxProps, Theme } from '@mui/material/styles';

import { useSidebar } from '../../context/SidebarContext';

import { SIDEBAR_DRAWER_WIDTH } from './header.constants';

const appBarSx = (drawerOpen: boolean): SxProps<Theme> => (theme) => ({
  zIndex: theme.zIndex.drawer + 1,
  ...(drawerOpen && {
    marginInlineStart: `${SIDEBAR_DRAWER_WIDTH}px`,
    width: `calc(100% - ${SIDEBAR_DRAWER_WIDTH}px)`,
  }),
});

const drawerToggleSx = (drawerOpen: boolean): SxProps<Theme> => ({
  marginInlineEnd: 4,
  ...(drawerOpen && { display: 'none' }),
});

interface HeaderBarProps {
  children: ReactNode;
}

export const HeaderBar = ({ children }: HeaderBarProps): JSX.Element => {
  const { t } = useTranslation();
  const { open, setOpen } = useSidebar();

  return (
    <AppBar position="fixed" sx={appBarSx(open)}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label={t('header.openDrawer', 'open drawer')}
          onClick={() => setOpen(true)}
          edge="start"
          sx={drawerToggleSx(open)}
        >
          <MenuIcon />
        </IconButton>
        {children}
      </Toolbar>
    </AppBar>
  );
};
